import { render, staticRenderFns } from "./PackagesSection.vue?vue&type=template&id=0f6c767c&scoped=true&"
import script from "./PackagesSection.vue?vue&type=script&lang=js&"
export * from "./PackagesSection.vue?vue&type=script&lang=js&"
import style0 from "./PackagesSection.vue?vue&type=style&index=0&id=0f6c767c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c767c",
  null
  
)

export default component.exports